import taxOptimizationsForm from "form/modal/taxOptimizations";
import { FORM_EDIT_TAX_OPTIMIZATION } from "../constants";

export const TaxOptimizationsForm = taxOptimizationsForm.createInPageContainer(FORM_EDIT_TAX_OPTIMIZATION);
